import { Box, CircularProgress, keyframes } from '@mui/material';

import logo from '@/assets/logo.svg';

// Custom keyframe animation replicating Tailwind's animate-pulse
const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export function LoadingPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh',
        gap: 4,
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="99minutos"
        sx={{
          width: 'auto',
          height: 64, // Equivalent to h-16 (16 * 4px = 64px)
          animation: `${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite`,
        }}
      />
      <CircularProgress color="primary" size={40} />
    </Box>
  );
}
